var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0303 0.431152C19.6908 0.431152 25.0862 5.83953 25.0862 12.5C25.0862 19.1733 19.6908 24.5689 13.0303 24.5689C6.35697 24.5689 0.961487 19.1733 0.961487 12.5C0.961487 5.83953 6.35697 0.431152 13.0303 0.431152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2276 7.67064C16.4663 7.20479 15.887 6.33003 15.7392 5.45518C15.7165 5.25068 15.6825 5.08023 15.6825 4.87573H13.3875V10.2837V14.033C13.3875 15.101 12.5126 15.9757 11.4447 15.9757C11.0925 15.9757 10.7971 15.8848 10.513 15.7485C9.8995 15.4304 9.4678 14.7601 9.4678 14.033C9.4678 12.9536 10.3313 12.0789 11.4447 12.0789C11.6379 12.0789 11.8196 12.1129 12.0241 12.1698V10.3633V9.84069C11.8196 9.8179 11.6379 9.78385 11.4447 9.78385C9.0815 9.78385 7.17279 11.6812 7.17279 14.033C7.17279 15.4531 7.88854 16.737 9.00195 17.4868C9.695 17.9526 10.5358 18.248 11.4447 18.248C13.7965 18.248 15.6825 16.3507 15.6825 14.033V9.26124C16.5572 10.0452 17.7161 10.4314 18.8749 10.3405V8.62494V8.04559C18.2956 8.15919 17.7161 7.98874 17.2276 7.67064Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMusicIcon);
export default __webpack_public_path__ + "static/media/dark_music_icon.d5608c93df46af8ed2b0161b38f97e71.svg";
export { ForwardRef as ReactComponent };